import { ck, URLS, interact } from "fire-wind-water";
import { setDomain, agentType } from "../../stempcore/src/sbase";
import URL from "../assets/conf/setting.json";
import service from "../services/article";
const tenantId = URLS.getURL("tenantId");
const articleId = URLS.getURL("articleId");
const isSetting = URLS.getURL("isSetting");
const articleCategoryId = URLS.getURL("articleCategoryId");
let browerType = interact.isMobile ? "mobile" : "pc";
if (URLS.getURL("isWap")) {
  browerType = "mobile";
}
setDomain(URL.template.cookie.domain);
ck.json = true;

const globalUserId = ck.cookie("globalUserId")
  ? ck.cookie("globalUserId").replace(/"/g, "")
  : "";

let getSess = function(schemaId) {
  return ck.cookie("smarketMember_" + schemaId)
    ? ck.cookie("smarketMember_" + schemaId).session
    : "";
};
let getMemberId = function(schemaId) {
  return ck.cookie("smarketMember_" + schemaId)
    ? ck.cookie("smarketMember_" + schemaId).memberId
    : "";
};

let initForm = function(identity, schemaId, id, tenantId, type, callBack) {
  if (identity == 3 && getSess(schemaId) == "") {
    //登陆后参与并且没有登录
    const param = {
      memberFormId: id,
      formId: id,
      globalUserId: globalUserId,
      keyword: "",
      num: 999,
      schemaId: schemaId,
      start: 0,
      tenantId: tenantId,
      trackId: "0"
    };
    service.getNewForm(param).subscribe(data => {
      const href = `${
        data.content[type + "SourceUrl"]
      }&backUrl=${encodeURIComponent(window.location.href)}`;
      window.$sk.goto(href);
    });
  } else {
    if (callBack) callBack();
  }
};

function emojiCN(input) {
  if (typeof input !== "string") {
    return "[空]";
  }
  var emojiInfos = {
      grinning: "笑",
      disappointed_relieved: "流汗",
      heart_eyes: "花痴",
      fearful: "难过",
      sob: "哭",
      flushed: "发呆",
      mask: "感冒",
      sleeping: "睡觉",
      cry: "流泪",
      sweat_smile: "心虚",
      rage: "愤怒",
      joy: "笑哭",
      grin: "嘻嘻",
      hushed: "吃惊",
      persevere: "折磨",
      sweat: "尴尬",
      weary: "痛苦",
      triumph: "生气",
      blush: "可爱",
      stuck_out_tongue_winking_eye: "鬼脸",
      dizzy_face: "衰",
      laughing: "爽",
      sleepy: "瞌睡",
      cold_sweat: "伤心",
      expressionless: "郁闷",
      smiley: "开心",
      sunglasses: "酷炫",
      smile: "大笑",
      no_mouth: "无语",
      relieved: "满意",
      pensive: "失落",
      confounded: "难忍",
      scream: "惊恐",
      stuck_out_tongue: "吐舌头",
      kissing_heart: "么么哒",
      unamused: "嫌弃",
      smirk: "嘚瑟",
      confused: "不甘",
      innocent: "天使微笑",
      wink: "眨眼",
      stuck_out_tongue_closed_eyes: "快乐",
      anguished: "失望",
      pig: "猪",
      joy_cat: "狗狗笑",
      scream_cat: "狗狗惊呆",
      grimacing: "呲牙",
      kissing_closed_eyes: "乐呵呵",
      speak_no_evil: "我不说",
      see_no_evil: "我不看",
      hear_no_evil: "我不听",
      beetle: "爬虫",
      sunny: "太阳",
      crescent_moon: "晚安",
      bomb: "炸弹",
      alien: "UFO",
      bear: "熊",
      cow: "奶牛",
      tea: "咖啡",
      broken_heart: "心碎",
      sparkling_heart: "爱心",
      zan: "强",
      "-1": "弱",
      clap: "鼓掌",
      wave: "招收",
      facepunch: "握拳",
      muscle: "力量",
      ok_hand: "OK",
      ghost: "幽灵",
      hibiscus: "鲜花",
      pray: "祈祷",
      kiss: "飞吻",
      imp: "暴怒",
      smiling_imp: "恶魔",
      rocket: "火箭",
      "100": "一百分",
      hankey: "便便",
      lollipop: "棒棒糖",
      moneybag: "钱钱钱",
      fire: "火",
      footprints: "脚丫"
    },
    emojis = [
      "100",
      "alien",
      "anguished",
      "bear",
      "beetle",
      "blush",
      "bomb",
      "broken_heart",
      "clap",
      "cold_sweat",
      "confounded",
      "confused",
      "cow",
      "cry",
      "disappointed_relieved",
      "dizzy_face",
      "-1",
      "expressionless",
      "facepunch",
      "fearful",
      "fire",
      "flushed",
      "ghost",
      "grimacing",
      "grin",
      "grinning",
      "hankey",
      "hear_no_evil",
      "heart_eyes",
      "hibiscus",
      "hushed",
      "innocent",
      "joy_cat",
      "joy",
      "kiss",
      "kissing_closed_eyes",
      "kissing_heart",
      "laughing",
      "lollipop",
      "mask",
      "moneybag",
      "muscle",
      "no_mouth",
      "ok_hand",
      "pensive",
      "persevere",
      "pig",
      "pray",
      "rage",
      "relieved",
      "rocket",
      "scream_cat",
      "scream",
      "see_no_evil",
      "sleeping",
      "sleepy",
      "smile",
      "smiley",
      "smiling_imp",
      "imp",
      "smirk",
      "sob",
      "sparkling_heart",
      "speak_no_evil",
      "stuck_out_tongue_closed_eyes",
      "stuck_out_tongue_winking_eye",
      "stuck_out_tongue",
      "sunglasses",
      "sunny",
      "sweat_smile",
      "sweat",
      "tea",
      "triumph",
      "unamused",
      "wave",
      "weary",
      "wink",
      "zan",
      "crescent_moon",
      "footprints"
    ],
    rEmojis = new RegExp(":(" + emojis.join("|") + "):", "g");
  return input.replace(rEmojis, function(match, text) {
    return "[" + emojiInfos[text] + "]";
  });
}

var updateSearchParam = function(key, value, originalUrl) {
  var rurl = originalUrl || window.location.href;
  var urls = rurl.match(/([^?#]+)?(\?[^#]+)?(#[^?]+)?(\?[\w\W]+)?/);
  if (!urls) {
    return rurl;
  }
  var url = urls[1] || "";
  var searchURL = urls[2] || "";
  var routerURL = urls[3] || "";
  var routerParam = urls[4] || "";
  if (searchURL) {
    var searchs = searchURL.replace(/^\?/, "").split("&");
    var newSearch = [];
    var newSearchJson = {};
    for (var i = 0; i < searchs.length; i++) {
      var items = searchs[i];
      var item = items.split("=");
      newSearchJson[item[0]] = true;
      if (item[0] === key) {
        newSearch.push(item[0] + "=" + value);
      } else {
        newSearch.push(item[0] + "=" + item[1]);
      }
    }
    if (!newSearchJson[key]) {
      newSearch.push(key + "=" + value);
    }
    searchURL = "?" + newSearch.join("&");
  } else {
    searchURL = "?" + key + "=" + value;
  }
  var rl = url + searchURL + routerURL + routerParam;
  return rl;
};

export {
  tenantId,
  articleId,
  globalUserId,
  getSess,
  articleCategoryId,
  initForm,
  isSetting,
  emojiCN,
  getMemberId,
  browerType,
  updateSearchParam,
  agentType
};
